(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lf-product-part"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-lf-sticky]');
    var target = document.querySelector('.product-form__submit');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    document.body.classList.add('lf-atc-watch');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        document.body.classList.toggle('lf-atc-gone', !bar.hidden);
      });
    }).observe(target);
  })();
  } catch(e) { console.error(e); }
})();

})();
